import React, { FC, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Container from '@mui/material/Container'

import routerSelectors from '@kaidam/fc-frontend/src/store/selectors/router'
import snackbarActions from '@kaidam/fc-frontend/src/store/modules/snackbar'

import {
  getTitle,
} from '@kaidam/fc-shared/src/utils/price'

const PayConfirm: FC<React.PropsWithChildren<unknown>> = () => {
  const dispatch = useDispatch()
  const params = useSelector(routerSelectors.params)

  let useAmount = parseInt(params.amount)
  if(isNaN(useAmount)) {
    useAmount = 0
  }

  useEffect(() => {
    dispatch(snackbarActions.setSuccess('Your payment has been confirmed'))
  }, [])
  
  return (
    <Container 
      maxWidth="lg" 
      sx={(theme) => ({
        padding: theme.spacing(4)
      })}
    >
      <Paper 
        sx={(theme) => ({
          padding: theme.spacing(4)
        })}
      >
        <Typography gutterBottom variant="h6">
          Payment Confirmed
        </Typography>
        <Typography gutterBottom>
          Amount: <strong>{ getTitle(useAmount) }</strong>
        </Typography>
        <Typography gutterBottom>
          Email: <strong>{ params.email }</strong>
        </Typography>
        <Typography gutterBottom variant="h6">
          Thank you for your payment!
        </Typography>
      </Paper>
    </Container>
  )
}

export default PayConfirm